export const GET_SUBSCRIBER = "GET_SUBSCRIBER";